import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

const Label = ({ className, hasError, children, ...rest }) => (
    <label className={classNames(styles.root, className)} {...rest}>
        {children}
    </label>
);

Label.propTypes = {
    className: PropTypes.string,
    hasError: PropTypes.bool,
    children: PropTypes.any,
};

Label.defaultProps = {
    hasError: false,
};

export default Label;
